import FTabMDP from "@/components/generic/FTabMDP";

export default class PartnerDetailsFTabMDP extends FTabMDP {
  taskRoot: any;

  constructor({ taskRoot }: { taskRoot: any }) {
    super({
      myRefName: "partnerDetailsFTabMDPRef",
    });
    this.taskRoot = taskRoot;

    this.addTab({
      tabName: "Partner Client File",
      routerName:
        "InstitutionalPartner.PartnerClientList.VerifiedClientList",
    }).addTab({
      tabName: "Unverified Client File",
      routerName:
        "InstitutionalPartner.PartnerClientList.UnverifiedClientList",
    });
  }

  getMyRef(): any {
    return this.taskRoot.$refs[this.myRefName];
  }
}
